import { BrowserRouter as Router, Routes, Route } from 'react-router-dom' 
import NavigationBar from './Components/NavigationBar'
import PrivateRoute from './Components/PrivateRoute'
import AlreadyLoggedIn from './Components/AlreadyLoggedIn'

import Login from './Pages/Login'
import Logout from './Pages/Logout'
import Home from './Pages/Home'
import Rotations from './Pages/Rotations'
import DailyPlanner from './Pages/Planner/Daily'
import RotationsPlanner from './Pages/Planner/Rotations'
import Staff from './Pages/Staff'
import Departments from './Pages/Departments'
import Roles from './Pages/Roles'
//import AppManager from './Pages/AppManager'
//import Downloads from './Pages/Downloads'
//import About from './Pages/About'
//import RequestAccess from './Pages/RequestAccess'

function App() {
  return (
    <div className="App">
        <Router>
            <Routes>
                <Route path="/" element={
                    <AlreadyLoggedIn to="/staff">
                        <NavigationBar />
                        <Home />
                    </AlreadyLoggedIn>
                } />
                <Route path="/departments" element={
                    <PrivateRoute to="/login">
                        <NavigationBar />
                        <Departments />
                    </PrivateRoute>
                } />
                <Route path="/roles" element={
                    <PrivateRoute to="/login">
                        <NavigationBar />
                        <Roles />
                    </PrivateRoute>
                } />

                <Route path="/staff" element={
                    <PrivateRoute to="/login">
                        <NavigationBar />
                        <Staff />
                    </PrivateRoute>
                } />
                <Route path="/login" element={ 
                    <AlreadyLoggedIn to="/staff">
                        <NavigationBar />
                        <Login to="/staff"/>
                    </AlreadyLoggedIn> 
                } />
                <Route path="/planner/daily" element={
                    <PrivateRoute to="/login">
                        <NavigationBar />
                        <DailyPlanner />
                    </PrivateRoute>
                }/> 
                <Route path="/planner/rotations" element={
                    <PrivateRoute to="/login">
                        <NavigationBar />
                        <RotationsPlanner />
                    </PrivateRoute>
                }/> 

                <Route path="/logout" element={ 
                    <Logout />
                } />
            </Routes>
        </Router>
    </div>
  );
}

export default App;
